// extracted by mini-css-extract-plugin
export default {"cityChooser":"c-j_cx","cityChooser__text":"c-j_cy","cityChooser__placeholder":"c-j_cz","cityChooser__buttonIcon":"c-j_cA"};